import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function StrokeIncrementRow() {
   return (
      <InputRangeRow
         titleProp={"Stroke Increment"}
         descriptionProp={"mm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0.1}
         maxProp={5.0}
         propertyNameProp={"strokeIncrement"}
         errorDialogueProp={"0.1-5.0"}
         floatProp={true}
      />
   );
}
